export enum OptimizedPictureType {
  OverviewMeeting = 'overviewMeeting',
  ResearchMeeting = 'researchMeeting',
  FeaturesBuilding = 'featuresBuildings',
  WhoUsesUsBusinessmen = 'whoUsesUsBusinessmen',
  AboutDoorLogo = 'aboutDoorLogo',
}
